import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'

class AppproveBloc {

    approveChannel = new Subject()
    typeChannel = new Subject()
    employeeListChannel = new Subject();
    detailChannel = new Subject()
    repository = new ApproveRepository()

    constructor() {
        this.approveChannel.next({ status: apiResponse.INITIAL })
        this.typeChannel.next({ status: apiResponse.INITIAL })
        this.employeeListChannel.next({ status: apiResponse.INITIAL })
        this.detailChannel.next({ status: apiResponse.INITIAL })
    }

    fetchDetail = async (query, cancelToken) => {
        this.detailChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.detailChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchEmployeeList = async (query) => {
        this.employeeListChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchEmployeeList(query).then((result) => {
            this.employeeListChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.employeeListChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchApprove = async (query) => {
        this.approveChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchApprove(query).then((result) => {
            this.approveChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.approveChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchType = async (query, cancelToken) => {
        this.typeChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchType(query, cancelToken).then((result) => {
            this.typeChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.typeChannel.next({ status: apiResponse.ERROR, data: error})
        })
    }

}

export default AppproveBloc